import React from "react";   
import HeaderComponent from "../../shared/components/HeaderComponent";
import FooterComponent from "../../shared/components/FooterComponent";
import { useLocation } from 'react-router-dom';
import Register from '../../shared/components/Register';
import SignIn from '../../shared/components/SignIn';
import ValidActive from '../../shared/components/ValidActive';
import LoginConfirmation from '../../shared/components/LoginConfirmation';

import lateralImg from './../../../assets/img/lateral.png'

import "./Login.scss";



// Login page
// Handles login routes
// Uses header and footer component
export default function Login() { 

  const location = useLocation(); 

  const showLocation = () => {
    if (location.pathname.includes('Register')) {
      return <Register/>;
    } else if (location.pathname.includes('SuccessConfirm')) {
      return <LoginConfirmation/>;
    } else if (location.pathname.includes('validactive')) {
      return <ValidActive/>;
    } else {
      return <SignIn/>
    }
  }
 
  return (
    <div className="login fixed w-screen h-screen">
      <HeaderComponent loginPage={true}></HeaderComponent> 
      <div className="login-container"> 
        <div>
          <img src={lateralImg} alt="" />
        </div>
        <div className={"content"}>
           { showLocation() }
        </div>
      </div>
      <FooterComponent loginPage={true}></FooterComponent>
    </div>
  );
} 